export default "__VITE_ASSET__BjHk57wV__"